import { GatsbyImage } from "gatsby-plugin-image";
import React, { useEffect, useRef, useState } from "react";
import { Flex } from "theme-ui";
import { useStaticQuery, graphql, Link } from "gatsby";
import Button from "../Buttons/Button";
import Nav from "../Nav/Nav";

interface Props {
  landing?: boolean;
  transparent?: boolean;
  variant: 1 | 2;
}

const Header = ({ landing, transparent, variant = 1 }: Props) => {
  const [navOpen, setNavOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(null);
  const headerRef = useRef(null);

  useEffect(() => {
    setHeaderHeight(headerRef?.current.offset);
  }, []);

  const data = useStaticQuery(graphql`
    query HeaderBlockQuery {
      refer: file(relativePath: { eq: "slides/ReferAFriendGraphic.png" }) {
        childImageSharp {
          gatsbyImageData(width: 300, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      heights: file(relativePath: { eq: "HeightsLogo_WebsiteVersion.png" }) {
        childImageSharp {
          gatsbyImageData(width: 343, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      heightsWhite: file(
        relativePath: { eq: "HeightsLogo_WebsiteVersionRev.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 343, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      southern: file(relativePath: { eq: "Southern Finance.png" }) {
        childImageSharp {
          gatsbyImageData(width: 150, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      quick: file(relativePath: { eq: "Quick Credit.png" }) {
        childImageSharp {
          gatsbyImageData(width: 150, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      convington: file(relativePath: { eq: "Covington Credit.png" }) {
        childImageSharp {
          gatsbyImageData(width: 150, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
    }
  `);

  const { heights, heightsWhite, southern, quick, convington } = data;

  return (
    <Flex
      sx={{
        justifyContent: "center",
        position: transparent ? "absolute" : "relative",
        top: [3, null, null, 0],
        pt: [0, null, null, 0],
        width: "100%",
      }}
    >
      <Flex
        ref={headerRef}
        sx={{
          position: ["relative"],
          alignItems: "center",
          justifyContent: "center",
          bg: [
            navOpen ? "darkBlue" : "white",
            null,
            null,
            navOpen ? "darkBlue" : "transparent",
          ],
          py: [2, null, null, 0],
          zIndex: 9,
          width: "100%",
          px: [3, null, null, 5],
          height: [variant == 2 ? "100%" : 120, null, null, 100],
        }}
      >
        <Flex
          sx={{
            maxWidth: 1920,
            width: "100%",
            justifyContent: "space-between",
            flexDirection: [variant == 2 ? "column" : "row", null, "row"],
          }}
        >
          <Flex
            sx={{
              alignItems: ["flex-start", null, "center"],
              flexDirection: ["column-reverse", null, "row"],
            }}
          >
            {navOpen ? (
              <Link to="/">
                <GatsbyImage
                  image={heightsWhite.childImageSharp.gatsbyImageData}
                  alt="Heights Logo"
                  sx={{
                    width: [150, null, null, 200],
                  }}
                />
              </Link>
            ) : (
              <Link to="/">
                <GatsbyImage
                  image={heights.childImageSharp.gatsbyImageData}
                  alt="Heights Logo"
                  sx={{
                    width: [150, null, null, 200],
                  }}
                />
              </Link>
            )}
            {!landing && (
              <Flex
                sx={{
                  alignItems: "center",
                  display: ["flex", null, "flex"],
                }}
              >
                <Link to="/southern-finance">
                  <GatsbyImage
                    image={southern.childImageSharp.gatsbyImageData}
                    alt="Heights Logo"
                    sx={{
                      mx: [1, null, 3],
                      width: [50, null, null, 80],
                    }}
                  />
                </Link>
                <Link to="/covington-credit">
                  <GatsbyImage
                    image={convington.childImageSharp.gatsbyImageData}
                    alt="Heights Logo"
                    sx={{
                      mx: [1, null, null, 3],
                      width: [50, null, null, 80],
                    }}
                  />
                </Link>
                <Link to="/quick-credit">
                  <GatsbyImage
                    image={quick.childImageSharp.gatsbyImageData}
                    alt="Heights Logo"
                    sx={{
                      mx: [1, null, null, 3],
                      width: [50, null, null, 80],
                    }}
                  />
                </Link>
              </Flex>
            )}
          </Flex>
          <Flex
            sx={{
              flexDirection: ["column-reverse", null, "row"],
              alignItems: [landing ? "flex-start" : "flex-end", null, "center"],
            }}
          >
            {landing ? (
              variant == 1 ? (
                <Button
                  to="/search-zipcode/"
                  variant="green"
                  text="APPLY NOW"
                  sx={
                    {
                      // mx: [0, null, 4, null, null, 5],
                    }
                  }
                />
              ) : (
                <Flex
                  sx={{
                    alignItems: ["left", null, null, "center"],
                    justifyContent: "center",
                    flexDirection: ["column", null, null, "row"],
                    gap: [2, null, null, 4],
                  }}
                >
                  <span
                    sx={{
                      color: "#9A9B9F",
                      textTransform: "uppercase",
                      fontWeight: 600,
                      fontSize: [18, null, null, null, 22, 27],
                      py: 2,
                    }}
                  >
                    Have an account?{" "}
                    <a
                      sx={{
                        color: "inherit",
                      }}
                      href="https://myaccount.heightsfinance.com/#/home/login/"
                    >
                      Login Here
                    </a>
                  </span>
                  <Button
                    text="APPLY NOW"
                    variant="green-filled"
                    href="https://apply.heightsfinance.com/"
                    sx={{ width: "fit-content" }}
                  />
                  <Button
                    text="GET OFFERS"
                    variant="green-filled"
                    href="https://apply.heightsfinance.com/"
                    sx={{
                      mb: [4, null, null, 0],
                      width: "fit-content",
                      bg: "brand.darkBlue",
                      "&:hover": {
                        bg: "brand.darkBlue",
                      },
                    }}
                  />
                </Flex>
              )
            ) : (
              <Button
                href="https://myaccount.heightsfinance.com/#/home/login/"
                variant="green"
                text="MYACCOUNT"
                sx={{
                  mx: [0, null, 4, null, null, 5],
                  p: 0,
                }}
              />
            )}
            {!landing && (
              <div
                sx={
                  {
                    // mr: 0,
                  }
                }
              >
                {navOpen ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="73.539"
                    height="73.538"
                    viewBox="0 0 73.539 73.538"
                    onClick={() => setNavOpen(false)}
                    sx={{
                      width: [30, null, null, 40],
                    }}
                  >
                    <g
                      id="Group_22"
                      data-name="Group 22"
                      transform="translate(0 73.539)"
                    >
                      <g
                        id="Group_20"
                        data-name="Group 20"
                        transform="translate(63.639 -73.539)"
                      >
                        <path
                          id="Path_21"
                          data-name="Path 21"
                          d="M0,0-63.639,63.639l9.9,9.9L9.9,9.9,0,0Z"
                          fill="#fff"
                        />
                      </g>
                      <g
                        id="Group_21"
                        data-name="Group 21"
                        transform="translate(9.898 -73.539)"
                      >
                        <path
                          id="Path_22"
                          data-name="Path 22"
                          d="M0,0-9.9,9.9l63.64,63.64,9.9-9.9L0,0Z"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="90"
                    height="67.5"
                    viewBox="0 0 90 67.5"
                    onClick={() => setNavOpen(true)}
                    sx={{
                      width: [30, null, null, 40],
                    }}
                  >
                    <g
                      id="Group_128"
                      data-name="Group 128"
                      transform="translate(0 67.5)"
                    >
                      <path
                        id="Path_132"
                        data-name="Path 132"
                        d="M0-54H90V-67.5H0Z"
                        fill="#2aa2da"
                      />
                      <path
                        id="Path_133"
                        data-name="Path 133"
                        d="M0-27H90V-40.5H0Z"
                        fill="#2aa2da"
                      />
                      <path
                        id="Path_134"
                        data-name="Path 134"
                        d="M0,0H90V-13.5H0Z"
                        fill="#2aa2da"
                      />
                    </g>
                  </svg>
                )}
              </div>
            )}
          </Flex>
        </Flex>
      </Flex>
      {!landing && <Nav logos={data} {...{ navOpen, setNavOpen }} />}
    </Flex>
  );
};

export default Header;
